// Stub: old item-kind renderer replaced by ScenarioEditor + ScenarioPlayer.
// KIND_TO_COMPONENT is kept as an empty map; defaultParamsFor keeps its full
// implementation because applyTemplateThunk / ActionPicker / InteractiveLibraryRail
// still call it to seed default params for old-style items.
export const KIND_TO_COMPONENT = {};

const POS = { x: 10, y: 10, w: 60, h: 30 };

export const defaultParamsFor = (kind) => {
  switch (kind) {
    case "FlipCard":
      return { front: "Front", back: "Back", position: { ...POS } };
    case "YesNo":
      return {
        prompt: "Yes or no?",
        correctAnswer: true,
        yesLabel: "Yes",
        noLabel: "No",
        onCorrectActions: [],
        onWrongActions: [],
        position: { ...POS },
      };
    case "TrueFalse":
      return {
        prompt: "True or false?",
        correctAnswer: true,
        trueLabel: "True",
        falseLabel: "False",
        onCorrectActions: [],
        onWrongActions: [],
        position: { ...POS },
      };
    case "MCQ":
    case "MultipleChoice":
      return {
        prompt: "Choose one",
        options: ["Option A", "Option B", "Option C", "Option D"],
        correctIndex: 0,
        onCorrectActions: [],
        onWrongActions: [],
        position: { ...POS, h: 40 },
      };
    case "MultipleAnswer":
      return {
        prompt: "Choose all that apply",
        options: ["Option A", "Option B", "Option C"],
        correctIndexes: [0],
        submitLabel: "Check",
        position: { ...POS, h: 40 },
      };
    case "FillInBlank":
      return {
        prompt: "Type the answer",
        acceptedAnswers: [""],
        caseSensitive: false,
        submitLabel: "Check",
        position: { ...POS },
      };
    case "DragDrop":
      return {
        prompt: "Drag to match",
        items: [],
        targets: [],
        correctPlacements: {},
        submitLabel: "Check",
        position: { ...POS, h: 50 },
      };
    case "Matching":
      return {
        prompt: "Match the pairs",
        leftItems: [],
        rightItems: [],
        correctPairs: {},
        submitLabel: "Check",
        position: { ...POS, h: 50 },
      };
    case "Ordering":
      return {
        prompt: "Put these in order",
        items: [],
        correctOrder: [],
        submitLabel: "Check",
        position: { ...POS, h: 45 },
      };
    case "BranchingQuestion":
      return {
        prompt: "What do you want to do next?",
        alternatives: [
          {
            id: "alt-0",
            label: "Option A",
            targetSceneId: null,
            targetActionChainId: null,
            feedback: "",
            score: 0,
            actions: [],
          },
          {
            id: "alt-1",
            label: "Option B",
            targetSceneId: null,
            targetActionChainId: null,
            feedback: "",
            score: 0,
            actions: [],
          },
        ],
        position: { ...POS, h: 45 },
      };
    case "MarkTheWords":
      return {
        prompt: "Click the verbs in the text",
        text: "The quick brown fox jumps over the lazy dog",
        correctWords: ["jumps"],
        position: { x: 10, y: 10, w: 70, h: 30 },
      };
    case "DialogCards":
      return { cards: [], position: { ...POS, h: 50 } };
    case "MemoryGame":
      return { cards: [], position: { ...POS, h: 50 } };
    case "DragTheWords":
      return { text: "Drag *word* here", position: { ...POS } };
    case "FindTheWords":
      return { words: [], grid: [], position: { ...POS, h: 50 } };
    case "ImageHotspots":
      return { imageUrl: "", hotspots: [], position: { ...POS, h: 50 } };
    case "QuestionSet":
      return { questions: [], position: { ...POS, h: 60 } };
    case "PersonalityQuiz":
      return { questions: [], results: [], position: { ...POS, h: 60 } };
    case "CoursePresentation":
      return { slides: [], position: { ...POS, h: 60 } };
    case "SpeakTheWords":
      return { prompt: "Say the phrase", acceptedPhrases: [], position: { ...POS } };
    case "ImageSequencing":
      return { images: [], correctOrder: [], position: { ...POS, h: 50 } };
    case "SingleChoiceSet":
      return { questions: [], position: { ...POS, h: 50 } };
    case "DragQuestion":
      return {
        prompt: "Drag to the correct zone",
        draggables: [],
        dropzones: [],
        correctPlacements: {},
        position: { ...POS, h: 50 },
      };
    case "Essay":
      return { prompt: "Write your response", position: { ...POS, h: 40 } };
    case "VisualLabel":
      return { labels: [], imageUrl: "", position: { ...POS } };
    case "VisualImage":
      return { imageUrl: "", caption: "", position: { ...POS } };
    case "visualtext":
      return { content: "", image: null, imagePosition: "top", buttons: [], position: { ...POS } };
    case "EndScreen":
      return { title: "Well done!", message: "", status: "win", position: { ...POS, h: 40 } };
    default:
      return { position: { ...POS } };
  }
};

export default function InteractivePluginRenderer() {
  return null;
}
